import { useAtomValue, useSetAtom } from 'jotai';
import { Notifications } from '@forma/forma-ui-kit';
import { notificationsAtom, removeNotificationAtom } from '@/store/notifications';

const NotificationsWrapper = () => {
  const notifications = useAtomValue(notificationsAtom);
  const removeNotification = useSetAtom(removeNotificationAtom);

  return (
    <Notifications
      items={notifications}
      onRemove={removeNotification}
    />
  );
};

export default NotificationsWrapper;
